export default __webpack_public_path__ + "static/rsz_wojciech-710x1024-c7d39e26c75f3845d9706702a2aa4a7a.jpg";